import styled, { css } from 'styled-components';

import { styledInteraction, styledLayout } from '@pkg/primitives';

import { tokens } from '../../tokens';

interface StyledIncomingProps {
    $compact?: boolean;
}

interface SectionProps {
    $center?: boolean;
    $compact?: boolean;
}

// TODO: We may want horizontal padding here,
// as it looks a bit awkward against the padded <Credits />.
export const StyledIncoming = styled.div<StyledIncomingProps>`
    ${styledLayout.fullWidthFix};

    --yat_incoming-activity-section-padding: ${({ $compact }) =>
        tokens.incoming.section.padding[$compact ? 'compact' : 'default']}px;
`;

export const Section = styled.div<SectionProps>`
    display: flex;
    align-items: center;
    justify-content: ${({ $center }) => ($center ? 'center' : 'space-between')};
    gap: ${tokens.incoming.section.gap}px;

    ${({ $compact }) => {
        if (!$compact) {
            return css`
                padding-top: var(--yat_incoming-activity-section-padding);
                padding-bottom: var(--yat_incoming-activity-section-padding);
                border-top: 1px solid rgba(255, 255, 255, 0.1);
            `;
        }
    }};

    &:last-child {
        padding-top: ${({ $compact }) => ($compact ? 'var(--yat_incoming-activity-section-padding)' : undefined)};
        padding-bottom: 0;
    }
`;

// TODO: This is temporary until we can implement a better Chip.
export const HackChipWrapper = styled.div`
    ${styledInteraction.interactionDisable};
    ${styledLayout.fullWidthFix};
`;
